import { useMutation } from '@tanstack/react-query';
import { passwordResetApi } from '@/lib/api/auth';

export function useForgotPassword() {
  return useMutation({
    mutationFn: (email: string) => passwordResetApi.forgotPassword(email),
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: ({ email, token, newPassword }: { email: string; token: string; newPassword: string }) =>
      passwordResetApi.resetPassword(email, token, newPassword),
  });
}
